<script setup>
import { useOrderStore } from '~/store/order'
import { useSpotStore } from '~/store/spot'
import { useUserStore } from '~/store/user'
import OrderLogin from '@/components/common/OrderLogin.vue'
import ws from '~/apis/spotSocket'

const { t } = useI18n()
const spot = useSpotStore()
const order = useOrderStore()
const user = useUserStore()
const localePath = useLocalePath()
const tab = ref('open')
ws.subscribe('spot_order')
onBeforeUnmount(() => {
  ws.unsubscribe('spot_order')
})
const tabs = computed(() => {
  return [
    {
      title: t('当前委托'),
      key: 'open',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Open.vue')),
      suffix: spot.ordersN,
      showOnlySelf: true,
    },
    {
      title: t('历史委托'),
      key: 'close',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Close.vue')),
      showOnlySelf: true,
    },
    {
      title: t('成交明细'),
      key: 'detail',
      component: defineAsyncComponent(() => import('@/components/orders/spot/Detail.vue')),
      showOnlySelf: true,
    },
  ]
})

function tabChange(value) {
  const current = order.current
  order.$reset()
  order.current = current
  order.tab = value
}
</script>

<template>
  <div class="h-[400px] bg-fillPagePrimary !mt-0.5 w-full">
    <CommonXMod :tab="tab" :tabs="tabs" class="h-full" need-login component-class="pb-4 h-[558px] min-w-full !w-[calc(100vw-300px)]" @tab-change="tabChange">
      <template #actions="{ showOnlySelf, key }">
        <ClientOnly>
          <template v-if="user.isLogin">
            <CommonXButton type="tertiary" class="!h-8" @click="spot.modal.cancelAll = true">
              {{ $t('一键撤单') }}
            </CommonXButton>
            <CommonXCheckbox v-if="showOnlySelf" v-model="order.current">
              <span class="text-xs">{{ $t('隐藏其他交易对') }}</span>
            </CommonXCheckbox>
            <NuxtLink class="inline-flex items-center text-textPrimary" :to="localePath(`/my/orders/spot/${key}`)">
              {{ $t('查看更多') }}
              <SvgoCommonArrowRight class="w-4 h-4 rtl:rotate-180" />
            </NuxtLink>
          </template>
        </ClientOnly>
      </template>
      <template #append>
        <ClientOnly>
          <OrderLogin v-if="!user.isLogin" />
        </ClientOnly>
      </template>
    </CommonXMod>
    <OrdersModalSpotCancelAll />
  </div>
</template>
